export default __webpack_public_path__ + "static/ux_paris_157-65eef172ab37bd5c5049400a3cedbc6d.jpg";